import { PUNCTUATION_MARKS_CONSTANTS } from '../constants/constants';

/**
 * Flattens rich-text/HTML content down to plain text.
 *
 * Lives here rather than in `common/notes/utils` so that data-layer modules can reach it
 * without loading the notes module's dependencies (`common/auth/api`, `person/person`), which
 * pull in the React app graph.
 */
export function stripHtmlToText(html: string): string {
    if (!html) return '';
    return html
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&quot;/gi, '"')
        .replace(/&#39;/gi, "'")
        .replace(/<br\s*\/?>/gi, PUNCTUATION_MARKS_CONSTANTS.newLine)
        .replace(/<[^>]+>/g, '')
        .replace(/\s+/g, ' ')
        .trim();
}
